module.exports = __webpack_public_path__ + "static/media/privacypolicy.c3c33be1.pdf";